export const RefreshIcon = (props: React.ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 12 12" {...props}>
      <path
        fill="currentColor"
        d="M2.102 10V8a.4.4 0 0 1 .4-.398h2l.08.008a.4.4 0 0 1 0 .781l-.08.009H3.285A3.67 3.67 0 0 0 6 9.6a3.6 3.6 0 0 0 3.573-3.15l.018-.079a.4.4 0 0 1 .774.178l-.03.202A4.4 4.4 0 0 1 6 10.399a4.47 4.47 0 0 1-3.1-1.25V10a.4.4 0 0 1-.799 0m.326-4.45a.4.4 0 0 1-.792-.099zm3.573-3.948c1.196 0 2.302.478 3.107 1.256V2a.4.4 0 0 1 .798 0v2a.4.4 0 0 1-.4.398H7.508a.399.399 0 0 1 0-.798h1.21A3.67 3.67 0 0 0 6 2.4a3.6 3.6 0 0 0-3.573 3.15l-.396-.05-.396-.049A4.4 4.4 0 0 1 6 1.601"
      />
    </svg>
  );
};
